"use client";

import { forwardRef, type InputHTMLAttributes } from "react";
import { Choice } from "./Choice";

export type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(props, ref) {
  return <Choice {...props} ref={ref} choiceType="checkbox" />;
});
